import React from "react";
import Navbar from "./components/navbar";
import HomePage from "./components/bannerhome";
import AppointmentSection from "./components/appointment";
import OurApproach from "./components/ourapproach";
import ConditionsWeTreat from "./components/conditions";
import Mission from "./components/mission"
import Blog from "./components/blog";
import LocationMap from "./components/locationmap";
import Footer from "./components/footer";
import AboutUs from "./components/aboutus";

function App() {
  return (
    <div>
      <Navbar />
      <HomePage />

      <AboutUs />          {/* Who you are */}
      <OurApproach />      {/* How you treat */}
      <ConditionsWeTreat />{/* What you treat */}

      <Mission />          {/* Trust + credibility */}

      <AppointmentSection /> {/* CTA after trust is built */}

     {/*  <Blog />  */}            {/* Optional credibility */}
     {/*  <LocationMap />  */}     {/* Location */}
      <Footer />
    </div>
  );
}

export default App;